// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".content[data-v-dbf8979a]{background:#efefef;display:flex;width:100%}.main-content[data-v-dbf8979a]{width:80%;margin:auto;vertical-align:middle;align-self:center}.title[data-v-dbf8979a]{color:#6b6b6b;font-size:4rem;margin-bottom:120px;font-weight:700;font-family:emoji;text-align:center;color:#000}.brief[data-v-dbf8979a]{text-indent:40px;line-height:35px;font-size:20px}", ""]);
// Exports
module.exports = exports;
